import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';
import { lang } from '../../../Utils';
import Attachments from './Attachments';
import Comments from './Comments';

const Left = () => <Tabs className="bf-enquiry-tabs bf-box-blue">
<TabList className="bf-enquiry-tabs-list">
  <Tab className="bf-enquiry-button">{lang('Comments')}</Tab>
  <Tab className="bf-enquiry-button">{lang('Attachments')}</Tab>
</TabList>
<TabPanels className="bf-enquiry-panels">
  <TabPanel className="bf-enquiry-panel">
    <Comments />
  </TabPanel>
  <TabPanel>
    <Attachments />
  </TabPanel>
</TabPanels>
</Tabs>

export default Left;